"use client";

import { useAgentWalletValidation } from "@/hooks/trade/hyperliquid/useAgentWalletValidation";

export function useAirdropAgentWalletValidation() {
  return useAgentWalletValidation({ mode: "airdrop" });
}
